import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from './Navbar';
import { useTranslation } from 'react-i18next';

const LoginPage = ({ setUser, setActiveRole, user }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const res = await axios.post('https://amora-backend.onrender.com/api/auth/login', formData);
      const user = res.data.user;
      const token = res.data.token;

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));

      sessionStorage.removeItem('amoraBetaDismissed');
      window.shouldResetBetaBanner = true;

      setUser(user);
      localStorage.setItem('activeRole', 'student');
      setActiveRole('student');
      navigate('/student-dashboard');
    } catch (err) {
      console.error('Login error:', err);
      setError(err.response?.data?.error || t('auth.loginError', 'Login failed'));
    }
  };

  return (
    <>
      <Navbar user={user} setUser={setUser} setActiveRole={setActiveRole} />
      <div className="min-h-[calc(100vh-64px)] bg-[#fcfaf4] text-[#2d2d2d] flex items-center justify-center px-6">
        <div className="bg-white border border-black p-10 w-full max-w-md font-serif">
          <h2 className="text-2xl font-extrabold uppercase text-center tracking-wide mb-6">
            🔐 {t('auth.loginTitle')}
          </h2>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-xs uppercase font-bold mb-1">{t('auth.email')}</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full border border-black bg-white text-black px-3 py-2 font-medium uppercase tracking-wide"
                required
              />
            </div>

            <div>
              <label className="block text-xs uppercase font-bold mb-1">{t('auth.password')}</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="w-full border border-black bg-white text-black px-3 py-2 font-medium uppercase tracking-wide"
                required
              />
            </div>

            {error && <p className="text-red-600 text-sm text-center">{error}</p>}

            <button
              type="submit"
              className="w-full border border-black bg-white text-black px-4 py-2 font-bold uppercase tracking-wide hover:bg-black hover:text-white transition"
            >
              {t('auth.loginButton')}
            </button>
          </form>

          <p className="text-center mt-6 text-xs font-medium text-[#4c4532]">
            {t('auth.noAccount')}{' '}
            <button
              onClick={() => navigate('/register')}
              className="underline hover:text-black transition"
            >
              {t('auth.registerLink')}
            </button>
          </p>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
